<template>
  <div>
    <!-- Mobile header -->
    <ApproveMobileHeader
      :surgeryType="surgery?.type"
      :isInfo="isInfo"
      :surgBeforeToday="surgBeforeToday"
      @approve="approve"
      @onEdit="onEdit"
      @approveGoBack="() => $emit('approveGoBack')"
    />
    <!-- Desktop header -->
    <ApproveDesktopHeader
      :isInfo="isInfo"
      @goBackRoute="goBackRoute"
      @approveGoBack="() => $emit('approveGoBack')"
    />

    <section
      v-if="surgery"
      class="aprove_sur_page aprove_sur_page-real relative desk_inner_width"
    >
      <div v-if="!isInfo" class="hold-subtitle no_mobile relative">
        <h2 class="subtitle center">עבור על פרטי הטופס ואשר</h2>
        <div class="bt_blue flex flex--content--center no-print" @click="print">
          <Print />הדפסה
        </div>
      </div>
      <div
        class="hold-all-sum-surg"
        :style="[isInfo ? { marginTop: '30px' } : '']"
      >
        <div class="no_mobile desk-flex">
          <div class="logo logo--blue surg-logo">
            <Logo />
          </div>

          <div v-if="isInfo">
            <h2 class="subtitle center reset-margin-bottom">
              עבור על פרטי הניתוח
            </h2>
            <div v-if="surgeryDate" class="">
              תאריך ושעת שיבוץ נוכחי: {{ surgeryDate }}
              <span v-if="surgeryTime">{{ surgeryTime }}</span>
            </div>
          </div>

          <div
            class="flex surg-msg-container"
            v-if="isInfo && surgery.type != 'ivf'"
          >
            <!-- Whatsapp button -->
            <div class="whatsapp-w" @click="handleWhatsapp(surgery.phone)">
              <img src="/assets/img/svg/wts-green.svg" alt="" />
            </div>
            <!-- SMS button -->
            <a
              class="flex"
              style="margin-right: 15px;"
              href="javascript:void(0);"
              @click="
                openSmsPopup(
                  surgery.id,
                  `${surgery.first_name} ${surgery.last_name}`,
                  surgery.passport
                )
              "
            >
              <img src="/assets/img/svg/sms-blue.svg" alt="" />
            </a>
          </div>
          <div v-if="!isInfo" class="tx--left">
            <div class="desk-tx--28">
              {{ todayDate }}
            </div>
            <div>{{ activeDoctor.name }}</div>
          </div>
        </div>
        <!-- Section -->
        <div class="inner_group">
          <h2 v-if="isInfo" class="subtitle_inner desk-hide">
            <div class="flex flex--between">
              <div style="max-width: 70%;">
                <div v-if="surgeryDate">
                  {{ surgeryDate }}
                  <span v-if="surgeryTime">{{ surgeryTime }}</span>
                </div>
                <div>{{ activeDoctor.name }}</div>
              </div>

              <div class="btns-w">
                <a
                  class="flex sms-btn-mobile"
                  href="javascript:void(0);"
                  @click="
                    openSmsPopup(
                      surgery.id,
                      `${surgery.first_name} ${surgery.last_name}`,
                      surgery.passport
                    )
                  "
                >
                  <img src="/assets/img/svg/sms-blue.svg" alt="" />
                </a>
                <div class="whatsapp-w" @click="handleWhatsapp(surgery.phone)">
                  <img src="/assets/img/svg/wts-green.svg" alt="" />
                </div>
              </div>
            </div>
          </h2>
          <h2 v-else class="subtitle_inner desk-hide">
            עבור על פרטי הטופס ואשר
          </h2>
        </div>

        <ApproveActions
          v-if="isInfo && surgery.type != 'ivf'"
          :surgStartDate="surgery.start_date"
          :surgBeforeToday="surgBeforeToday"
          @cancelSurg="ev => cancelSurg(ev)"
          @onEdit="onEdit"
          @addDirectDocs="addDirectDocs"
          @patientRequests="openPatientRequests"
        />

        <div class="inner_group bg--white">
          <h3 class="aprove_sur_title tx--blue ft--400">פרטי מטופל</h3>
        </div>
        <div class="aprove_sur_list desk-flex desk-flex--top">
          <div class="add_new_row flex desk-surg-col3">
            <div class="add_new_row_col1 tx--black ft--400">שם מלא</div>
            <div class="add_new_row_col2">
              {{ surgery.first_name }} {{ surgery.last_name }}
            </div>
          </div>
          <div class="add_new_row flex desk-surg-col3">
            <div class="add_new_row_col1 tx--black ft--400">ת.ז</div>
            <div class="add_new_row_col2">{{ surgery.passport }}</div>
          </div>
          <div class="add_new_row flex desk-surg-col3">
            <div class="add_new_row_col1 tx--black ft--400">תאריך לידה</div>
            <div class="add_new_row_col2">
              {{
                $moment(
                  surgery.birth_date,
                  isInfo ? "YYYY-MM-DD" : "DD-MM-YYYY"
                ).format("DD/MM/YYYY")
              }}
            </div>
          </div>
          <div class="add_new_row flex desk-surg-col3">
            <div class="add_new_row_col1 tx--black ft--400">מין</div>
            <div class="add_new_row_col2">
              {{ surgery.gender == "male" ? "זכר" : "נקבה" }}
            </div>
          </div>
          <div class="add_new_row flex desk-surg-col3">
            <div class="add_new_row_col1 tx--black ft--400">טלפון</div>
            <div class="add_new_row_col2">{{ surgery.phone }}</div>
          </div>
          <div
            class="add_new_row flex desk-surg-col3"
            v-if="surgery.second_phone"
          >
            <div class="add_new_row_col1 tx--black ft--400">טלפון נוסף</div>
            <div class="add_new_row_col2">{{ surgery.second_phone }}</div>
          </div>
          <div class="add_new_row flex desk-surg-col3" v-if="userLang">
            <div class="add_new_row_col1 tx--black ft--400">שפה</div>
            <div class="add_new_row_col2">{{ userLang }}</div>
          </div>
          <div class="add_new_row flex desk-surg-col3" v-if="surgery.apotropos">
            <div class="add_new_row_col1 tx--black ft--400">אפוטרופוס</div>
            <div class="add_new_row_col2">{{ surgery.apotropos }}</div>
          </div>
          <div
            class="add_new_row flex desk-surg-col3"
            v-if="getParentalStatus?.text"
          >
            <div class="add_new_row_col1 tx--black ft--400">
              סטטוס משפחתי של ההורים
            </div>
            <div class="add_new_row_col2">{{ getParentalStatus.text }}</div>
          </div>
          <div class="add_new_row flex desk-surg-col3" v-if="surgery.email">
            <div class="add_new_row_col1 tx--black ft--400">אימייל</div>
            <div class="add_new_row_col2">{{ surgery.email }}</div>
          </div>
        </div>
        <!--/פרטי מטפל-->

        <div class="inner_group bg--white">
          <h3 class="aprove_sur_title tx--blue ft--400">פרטי ניתוח</h3>
        </div>
        <div class="aprove_sur_list desk-flex desk-flex--top">
          <div
            class="add_new_row flex desk-surg-col3"
            v-if="surgery.hospitalization"
          >
            <div class="add_new_row_col1 tx--black ft--400">ימי אשפוז</div>
            <div class="add_new_row_col2">
              {{
                getSelectTextByValue("hospitalization", surgery.hospitalization)
              }}
            </div>
          </div>
          <div
            class="add_new_row flex desk-surg-col3"
            v-if="surgery.insurance_name"
          >
            <div class="add_new_row_col1 tx--black ft--400">גורם משלם</div>
            <div class="add_new_row_col2">{{ surgery.insurance_name }}</div>
          </div>
          <div
            class="add_new_row flex desk-surg-col3"
            v-if="surgery.handle_insurance_claim_by_hmc"
          >
            <div class="add_new_row_col1 tx--black ft--400" style="width: 60%;">
              מעוניין שבית החולים יפנה בשמך לחברת הביטוח
            </div>
            <div class="add_new_row_col2" style="width: 30%;">
              {{
                surgery.handle_insurance_claim_by_hmc == "approved"
                  ? "מאושר"
                  : "לא מאושר"
              }}
            </div>
          </div>
          <div
            class="add_new_row flex desk-surg-col3"
            v-if="surgery.doctor_fee"
          >
            <div class="add_new_row_col1 tx--black ft--400">שכר טרחה</div>
            <div class="add_new_row_col2">₪{{ surgery.doctor_fee }}</div>
          </div>
          <div
            class="add_new_row flex desk-surg-col3"
            v-if="surgery.secondary_insurance_name"
          >
            <div class="add_new_row_col1 tx--black ft--400">
              {{ secondaryInsuranceLabel }}
            </div>
            <div class="add_new_row_col2">
              {{ secondaryInsurance }}
            </div>
          </div>
          <div v-if="isInfo" class="add_new_row flex desk-surg-col3">
            <div class="add_new_row_col1 tx--black ft--400">
              סך השתתפות עצמית
            </div>
            <div class="add_new_row_col2">
              ₪{{ surgery.insurance_fee ? surgery.insurance_fee : 0 }}
            </div>
          </div>
          <div class="add_new_row flex desk-surg-col3">
            <div class="add_new_row_col1 tx--black ft--400">אסיסטנט</div>
            <div class="add_new_row_col2">
              {{
                getSelectTextByValue(
                  "assistant_status",
                  surgery.assistant_status
                )
              }}
            </div>
          </div>
          <div
            class="add_new_row flex desk-surg-col3"
            v-if="surgery.assistant_name"
          >
            <div class="add_new_row_col1 tx--black ft--400">שם אסיסטנט</div>
            <div class="add_new_row_col2">{{ surgery.assistant_name }}</div>
          </div>
          <div class="add_new_row flex desk-surg-col3">
            <div class="add_new_row_col1 tx--black ft--400">הרדמה</div>
            <div class="add_new_row_col2 desk-hide">
              {{ getSelectTextByValue("anesthesia", surgery.anesthesia) }}
            </div>
            <div class="add_new_row_col2 no_mobile">
              {{ getSelectTextByValue("anesthesia", surgery.anesthesia) }}
            </div>
          </div>
          <div class="add_new_row flex desk-surg-col3" v-if="surgery.xray_type">
            <div class="add_new_row_col1 tx--black ft--400">סוג צילום</div>
            <div class="add_new_row_col2">
              {{ getSelectTextByValue("xray_type", surgery.xray_type) }}
            </div>
          </div>
          <div
            class="add_new_row flex desk-surg-col3"
            v-if="surgery.frozen_cut"
          >
            <div class="add_new_row_col1 tx--black ft--400">
              חתך קפוא (FS)
            </div>
            <div class="add_new_row_col2">
              {{ getSelectTextByValue("frozen_cut", surgery.frozen_cut) }}
            </div>
          </div>
          <div class="add_new_row flex desk-surg-col3" v-if="surgery.resources">
            <div class="add_new_row_col1 tx--black ft--400">
              משאבים נדרשים
            </div>
            <div class="add_new_row_col2">{{ surgery.resources }}</div>
          </div>
          <template v-for="item in requests">
            <div
              v-if="surgery[item.value] == 'כן'"
              class="add_new_row flex desk-surg-col3"
              :key="item.value"
            >
              <div class="add_new_row_col1 tx--black ft--400">
                {{ item.text }}
              </div>
              <div class="add_new_row_col2">כן</div>
            </div>
          </template>
          <div
            v-if="surgery.pre_surgery_override"
            class="add_new_row flex desk-surg-col3"
          >
            <div class="add_new_row_col1 tx--black ft--400">
              נדרש טרום ניתוח
            </div>
            <div class="add_new_row_col2">כן</div>
          </div>
          <div
            class="add_new_row desk-surg-col3 w-100 desk-w-100"
            v-if="surgery.notes"
          >
            <div class="add_new_row_col1 w-100 tx--black ft--400">
              הערות כלליות
            </div>
            <div class="add_new_row_col2 w-100 text-sm">
              {{ surgery.notes }}
            </div>
          </div>
          <div
            v-if="implants"
            class="add_new_row desk-surg-col3 w-100 desk-w-100"
          >
            <div class="add_new_row_col1 w-100 tx--black ft--400">
              משתלים וציוד רפואי
            </div>
            <div class="add_new_row_col2 w-100 text-sm">
              {{ implants }}
            </div>
          </div>
        </div>
        <!--/פרטי ניתוח-->

        <template v-if="displayedPatientRequests.length">
          <div class="inner_group bg--white">
            <h3 class="aprove_sur_title tx--blue ft--400">
              בקשות מטופל לבית החולים
            </h3>
          </div>
          <div
            v-for="(request, index) in displayedPatientRequests"
            :key="request.category || index"
            class="aprove_sur_list desk-flex desk-flex--top"
          >
            <div
              v-if="request.category"
              class="add_new_row flex desk-surg-col3"
            >
              <div class="add_new_row_col1 tx--black ft--400">
                סוג הבקשה
              </div>
              <div class="add_new_row_col2">
                {{ request.category }}
              </div>
            </div>
            <div class="add_new_row flex desk-surg-col3">
              <div class="add_new_row_col1 tx--black ft--400">
                פירוט
              </div>
              <div class="add_new_row_col2">
                {{ request.description }}
              </div>
            </div>
          </div>
        </template>

        <!-- Section -->
        <div
          class="inner_group bg--white"
          v-if="surgery.current_surgery?.length"
        >
          <h3 class="aprove_sur_title tx--blue ft--400">
            פרטי ניתוח מתוכנן
          </h3>
        </div>
        <div v-if="surgery.current_surgery?.length" class="aprove_sur_list">
          <div class="no_mobile surg_list_head desk-flex">
            <div class="surg_list-1">ניתוח ראשי</div>
            <div class="surg_list-2">צד</div>
            <!-- <div class="surg_list-2">תחום</div> -->
            <div class="surg_list-3">שם/קוד ניתוח (בי״ח)*</div>
            <div class="surg_list-4">שם/קוד ניתוח (קליני ICD9)*</div>
            <div class="surg_list-5">משך (ברוטו)</div>
          </div>
          <div
            v-for="(s, index) in surgery.current_surgery"
            :key="index"
            class="desk-flex surg_list_ans"
          >
            <div class="surg_list-1">
              {{ s.is_primary ? "✓" : "" }}
              <span class="mobile_only_inline"
                >{{ s.is_primary ? "ראשי" : "" }}
              </span>
            </div>
            <div class="surg_list-2">{{ s.side }}</div>
            <!-- <div class="surg_list-2">{{ s.surgery_category }}</div> -->
            <div class="surg_list-3">
              {{ s.surgery_name }}
            </div>
            <div class="surg_list-4">
              {{ s.procedure }}
            </div>
            <div class="surg_list-5">
              {{ s.surgery_duration }}
            </div>
          </div>
        </div>

        <div
          class="inner_group bg--white"
          v-if="surgery.insurance_surgery?.length"
        >
          <h3 class="aprove_sur_title tx--blue ft--400">
            פרטי ניתוח של גורם מבטח
          </h3>
        </div>
        <div class="aprove_sur_list" v-if="surgery.insurance_surgery?.length">
          <div class="no_mobile surg_list_head desk-flex">
            <div class="surg_list-1">מבטח</div>
            <div class="surg_list-2">קוד ניתוח</div>
            <!-- <div class="surg_list-3">תחום</div> -->
            <div class="surg_list-3">שם/קוד ניתוח</div>
            <div class="surg_list-5">הערות</div>
          </div>
          <div
            v-for="(item, i) in surgery.insurance_surgery"
            :key="i"
            class="desk-flex"
          >
            <div class="surg_list-1">{{ item.insurance }}</div>
            <div class="surg_list-2" style="word-break: break-word;">
              {{ surgery.current_surgery[i]?.surgery_name }}
            </div>
            <!-- <div class="surg_list-3">
              {{ item.surgery_category }}
            </div> -->
            <div class="surg_list-3">
              {{ item.surgery_name }}
            </div>
            <div class="surg_list-5">
              {{ item.notice }}
            </div>
          </div>
        </div>

        <!-- Surgery indication -->
        <div v-if="surgery.indication" class="inner_group bg--white">
          <h3 class="aprove_sur_title tx--blue ft--400">
            אינדיקציה לניתוח
          </h3>
        </div>
        <div v-if="surgery.indication" class="aprove_sur_list">
          <div class="surg_list_head desk-flex">
            <div class="keep-line-breaks">{{ surgery.indication }}</div>
          </div>
        </div>

        <div
          class="inner_group bg--white"
          v-if="surgery.current_diagnosis?.length"
        >
          <h3 class="aprove_sur_title tx--blue ft--400">
            אבחנה נוכחית לפעולה
          </h3>
        </div>
        <div v-if="surgery.current_diagnosis?.length" class="aprove_sur_list">
          <div class="no_mobile surg_list_head desk-flex">
            <div class="surg_list-1">צד</div>
            <div class="surg_list-2">קוד אבחנה</div>
            <div class="surg_list-3">שם אבחנה (ניתן לחפש לפי קוד)*</div>
            <div class="surg_list-5">הערות</div>
          </div>
          <div
            v-for="(item, i) in surgery.current_diagnosis"
            :key="i"
            class="desk-flex surg_list_ans"
          >
            <div class="surg_list-1">{{ item.side }}</div>
            <div class="surg_list-2">
              {{ item.diagnosis_number }}
            </div>
            <div class="surg_list-3">
              {{ item.diagnosis_name }}
            </div>
            <div class="surg_list-5">
              {{ item.notice }}
            </div>
          </div>
        </div>

        <!-- Past / background diagnoses -->

        <div
          class="inner_group bg--white"
          v-if="
            surgery.past_diagnosis?.length || surgery.checkbox_past_diagnosis
          "
        >
          <h3 class="aprove_sur_title tx--blue ft--400">
            אבחנות רקע
          </h3>
        </div>
        <div v-if="surgery.past_diagnosis?.length" class="aprove_sur_list">
          <div class="no_mobile surg_list_head desk-flex">
            <div class="surg_list-1">צד</div>
            <div class="surg_list-2">קוד אבחנה</div>
            <div class="surg_list-3">שם אבחנה (ניתן לחפש לפי קוד)*</div>
            <div class="surg_list-5">הערות</div>
          </div>
          <div
            v-for="(item, i) in surgery.past_diagnosis"
            :key="i"
            class="desk-flex surg_list_ans"
          >
            <div class="surg_list-1">{{ item.side }}</div>
            <div class="surg_list-2">
              {{ item.diagnosis_number }}
            </div>
            <div class="surg_list-3">
              {{ item.diagnosis_name }}
            </div>
            <div class="surg_list-5">
              {{ item.notice }}
            </div>
          </div>
        </div>
        <div class="aprove_sur_list" v-if="surgery.checkbox_past_diagnosis">
          בריא בדרך כלל
        </div>

        <!-- בדיקה גופנית  -->
        <div v-if="surgery.physical_examination" class="inner_group bg--white">
          <h3 class="aprove_sur_title tx--blue ft--400">
            בדיקה גופנית
          </h3>
        </div>
        <div v-if="surgery.physical_examination" class="aprove_sur_list">
          <div class="surg_list_head desk-flex">
            <div>{{ surgery.physical_examination }}</div>
          </div>
        </div>

        <!-- רגישות לתרופות  -->
        <div
          class="inner_group bg--white"
          v-if="surgery.medication_sensitivity?.length"
        >
          <h3 class="aprove_sur_title tx--blue ft--400">
            רגישות לתרופות
          </h3>
        </div>
        <div
          class="aprove_sur_list"
          v-if="surgery.medication_sensitivity?.length"
        >
          <div class="no_mobile surg_list_head desk-flex">
            <div class="surg_list-1">תגובה</div>
            <div class="surg_list-2">חומרה</div>
            <div class="surg_list-3">שם תרופה</div>
            <div class="surg_list-5">הערות</div>
          </div>
          <div
            v-for="(item, i) in surgery.medication_sensitivity"
            :key="i"
            class="desk-flex surg_list_ans"
          >
            <div class="surg_list-1">
              {{ item.response }}
            </div>
            <div class="surg_list-2">
              {{ item.severity }}
            </div>
            <div class="surg_list-3">
              {{ item.medication }}
            </div>
            <div class="surg_list-5">
              {{ item.notice }}
            </div>
          </div>
        </div>

        <!-- רגישות לחומרים  -->
        <div
          class="inner_group bg--white"
          v-if="surgery.material_sensitivity?.length"
        >
          <h3 class="aprove_sur_title tx--blue ft--400">
            רגישות לחומרים
          </h3>
        </div>
        <div
          class="aprove_sur_list"
          v-if="surgery.material_sensitivity?.length"
        >
          <div class="no_mobile surg_list_head desk-flex">
            <div class="surg_list-1">תגובה</div>
            <div class="surg_list-2">חומרה</div>
            <div class="surg_list-3">שם חומרה</div>
            <div class="surg_list-5">הערות</div>
          </div>
          <div
            v-for="(item, i) in surgery.material_sensitivity"
            :key="i"
            class="desk-flex surg_list_ans"
          >
            <div class="surg_list-1">
              {{ item.response }}
            </div>
            <div class="surg_list-2">
              {{ item.severity }}
            </div>
            <div class="surg_list-3">
              {{ item.material_name }}
            </div>
            <div class="surg_list-5">
              {{ item.notice }}
            </div>
          </div>
        </div>
        <!-- files -->
        <template v-if="existFiles">
          <div v-for="(fileRow, j) in files" :key="fileRow.title">
            <div v-if="fileRow.files?.length" class="inner_group bg--white">
              <h3 class="aprove_sur_title tx--blue ft--400">
                מסמכים מצורפים - {{ fileRow.title.replace(/\*/g, "") }}
              </h3>
            </div>
            <div
              v-if="fileRow.files?.length"
              class="aprove_sur_list add_new_row_docs m-pt-15 flex flex--start svg-block"
            >
              <!-- <div class="add_new_row_col1 w-100">
              {{ fileRow.title.replace(/\*/g, "") }}
            </div> -->
              <a
                class="file_item relative flex desk-block"
                v-for="(file, index) in fileRow.files"
                href="javascript:void(0)"
                :key="index"
                @click.prevent="getDoc(file.path, file.name)"
              >
                <span
                  v-show="isInfo"
                  @click.stop="removeFile(j, index)"
                  class="file-remove"
                >
                  <CloseSvg />
                </span>
                <img class="" src="/assets/img/svg/ic-file.svg" />
                <span class="tx_file block">{{ file.name }}</span>
              </a>
            </div>
          </div>
        </template>
        <!-- insurance -->
        <div
          v-if="
            isInfo && (surgery.insurance_status_heb || surgery.insurance_code)
          "
          class="inner_group bg--white"
        >
          <h3 class="aprove_sur_title tx--blue ft--400">
            פרטי התחייבות מגורם משלם
          </h3>
        </div>
        <div class="aprove_sur_list">
          <div style="padding:3px 0;" v-if="surgery.insurance_status_heb">
            <span class="bold">סטטוס התחייבות:</span>
            {{ surgery.insurance_status_heb }}
          </div>
          <div style="padding:3px 0;" v-if="surgery.insurance_code">
            <span class="bold">מספר התחייבות:</span>
            {{ surgery.insurance_code }}
          </div>
        </div>
        <!-- pre_surgery_appointments -->
        <template v-if="isInfo && surgery.pre_surgery_appointments?.length">
          <div class="inner_group bg--white">
            <h3 class="aprove_sur_title tx--blue ft--400">
              פרטי טרום ניתוח
            </h3>
          </div>
          <div
            v-for="(item, i) in surgery.pre_surgery_appointments"
            :key="i"
            class="aprove_sur_list"
          >
            <div v-if="item.pre_surgery_status_heb" style="padding:3px 0;">
              <span class="bold">סטטוס קביעת טרום ניתוח:</span>
              {{ item.pre_surgery_status_heb }}
            </div>
            <div
              v-if="item.start_datetime && item.end_datetime"
              style="padding:3px 0;"
            >
              <span class="bold">תאריך טרום ניתוח:</span>
              {{
                $moment(new Date(item.start_datetime)).format(
                  "DD/MM/YYYY יום dddd, "
                ) +
                  $moment(new Date(item.start_datetime)).format("HH:mm") +
                  "-" +
                  $moment(new Date(item.end_datetime)).format("HH:mm")
              }}
            </div>
          </div>
        </template>
      </div>
      <!-- aprove_sur_note  -->
      <template v-if="!isInfo">
        <div class="aprove-sur-check desk-flex">
          <span class="surgery-check flex flex--top flex--start">
            <span
              class="surgery-check flex"
              :class="isApprove ? 'active' : ''"
              @click.stop="onApprove"
            >
              <span class="surgery-check-ic block"></span>
              מאשר/ת את פרטי הניתוח המוצגים
            </span>
          </span>
        </div>
        <div class="error-message" v-if="approveErr">{{ approveErr }}</div>
        <div class="aprove-sur-check desk-flex">
          <span class="surgery-check flex flex--top flex--start">
            <span
              class="surgery-check flex"
              :class="isPatientApprove ? 'active' : ''"
              @click.stop="isPatientApprove = !isPatientApprove"
            >
              <span class="surgery-check-ic block"></span>
              המטופל קיבל הסבר אודות הניתוח
            </span>
          </span>
        </div>
        <div class="form_submit center no-print">
          <input
            type="submit"
            @click="approve"
            style="border-radius: 0;"
            value="אישור ניתוח"
          />
        </div>
      </template>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import Print from "@/assets/img/svg/ic-print.svg";
import Logo from "@/assets/img/svg/logo.svg";
import CloseSvg from "@/assets/img/svg/close.svg";
import ConfirmSurg from "@/components/Popups/ConfirmSurg";
import Error from "@/components/Popups/Error";
import CancelPop from "@/components/Popups/CancelApp";
import SMSToPatient from "@/components/Popups/SMSToPatient";
import Whatsapp from "@/components/Popups/Whatsapp";
import surgerySelect from "../../../../mixins/surgerySelect.json";
import { getHash } from "../../../../utilities/hash.js";
import { convertToBase64 } from "../../../../utilities/globals";
import {
  insuranceQuestions,
  getShortCareServices,
  parentalStatus
} from "../../../../utilities/surgery-questions.js";
import { getSurgeryErrorPopup } from "../../../../utilities/get-init-popup";
import ApproveMobileHeader from "./ApproveMobileHeader.vue";
import ApproveDesktopHeader from "./ApproveDesktopHeader.vue";
import ApproveActions from "./ApproveActions.vue";
import AddDocuments from "@/components/Popups/AddDocuments";
import ConfirmDelete from "@/components/Popups/ConfirmDelete.vue";
import PatientRequestsPopup from "@/components/Popups/PatientRequests.vue";
import {
  buildPatientRequestPayloads,
  createEmptyPatientRequests,
  getPatientRequestSummary
} from "@/utilities/patient-requests";

export default {
  name: "SurgApprove",
  props: {
    surgery: {
      required: true
    },
    files: {
      required: true
    },
    filesType: {
      default: () => "medicaldocuments-patient"
    },
    beforeEditFiles: {
      default: () => []
    },
    isInfo: {
      type: Boolean,
      default: false
    },
    isAfterEdit: {
      type: Boolean,
      default: false
    },
    patientRequests: {
      type: Object,
      default: createEmptyPatientRequests
    },
    sentRequestTypes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      parentalStatus,
      insuranceQuestions,
      surgerySelect,
      isApprove: false,
      isPatientApprove: true,
      patient: "",
      documents: [],
      appointment: "",
      approveSurgSum: true,
      approveErr: null,
      isOnSubmit: false,
      requests: [
        {
          value: "monitoring_request",
          text: "נדרש ניטור"
        },
        {
          value: "blood",
          text: "הזמנת מוצרי דם"
        },
        {
          value: "icu",
          text: "אשפוז בטיפול נמרץ"
        },
        {
          value: "tee_request",
          text: "נדרש T.E.E."
        },
        {
          value: "navigation_request",
          text: "נדרש ניווט"
        }
      ]
    };
  },
  methods: {
    ...mapActions(["SET_SURGERY"]),
    convertToBase64,
    getShortCareServices,
    async approve() {
      if (!this.isApprove) {
        this.approveErr = "שדה חובה";
        return;
      }
      if (this.isOnSubmit) return;
      this.isOnSubmit = true;
      try {
        this.surgery.checkbox_patient_doctor_disclaimer = this.isPatientApprove
          ? 1
          : 0;

        const temp_surgery = JSON.parse(sessionStorage.getItem("temp_surgery"));
        if (temp_surgery) this.surgery.surgery_id = temp_surgery;

        let req = { ...this.surgery };
        req.pre_surgery_override = this.surgery.pre_surgery_override
          ? "pre_needed"
          : null;
        req.surgery_form = "with_orders";
        delete req.insurance_surgery;
        delete req.current_surgery;

        const res = await this.$API.scheduleSuregery(req);
        if (res.status == "OK") {
          const surgeryId =
            res.surgery_id || this.surgery.surgery_id || temp_surgery;
          const requestPayloads = buildPatientRequestPayloads(
            surgeryId,
            this.patientRequests,
            this.sentRequestTypes
          );
          const requestResults = await Promise.all(
            requestPayloads.map(payload =>
              this.$API
                .savePatientRequest(payload)
                .then(response => response?.status !== "ERROR")
                .catch(() => false)
            )
          );
          const hasFailedPatientRequests = requestResults.some(
            result => !result
          );

          sessionStorage.removeItem("temp_surgery");
          this.SET_SURGERY(null);
          // this.uploadFiles(res.surgery_id);

          this.$modal.show(
            ConfirmSurg,
            {
              title: this.isAfterEdit ? "עריכת" : "יצירת",
              notice: hasFailedPatientRequests
                ? "הניתוח נשמר, אך לא ניתן היה להעביר את בקשות המטופל. ניתן לנסות שוב מתפריט שלוש הנקודות לצד הניתוח."
                : ""
            },
            {},
            {
              closed: () => {
                this.approveErr = null;
                this.isApprove = false;
              }
            }
          );
        } else {
          this.$modal.show(Error);
        }
      } catch (err) {
        this.$modal.show(Error);
      }
      this.isOnSubmit = false;
    },
    onApprove() {
      this.isApprove = !this.isApprove;
    },
    print() {
      window.focus();
      window.print();
    },
    async uploadFiles(id) {
      if (this.beforeEditFiles?.length) {
        for (const [index, currentCategory] of this.files.entries()) {
          const beforeCategory = this.beforeEditFiles[index];

          const newFiles = currentCategory.files.filter(
            file =>
              file instanceof File &&
              !beforeCategory.files.find(f => f.id == file.id)
          );
          if (newFiles.length) {
            const filesArray = [];
            for (const file of newFiles) {
              const base64 = await this.convertToBase64(file);
              filesArray.push({ filename: file.name, mime: file.type, base64 });
            }
            await this.$API.uploadFile(
              id,
              "new",
              null,
              "",
              filesArray,
              true,
              currentCategory.type
            );
          }

          beforeCategory.files.forEach(file => {
            if (!currentCategory.files.find(f => f.id == file.id)) {
              this.$API.uploadFile(
                id,
                "cancel",
                file.id,
                file.name,
                [],
                true,
                currentCategory.type
              );
            }
          });
        }
      } else {
        for (const currentCategory of this.files) {
          const newFiles = currentCategory.files.filter(
            file => file instanceof File
          );
          if (newFiles.length) {
            const filesArray = [];
            for (const file of newFiles) {
              const base64 = await this.convertToBase64(file);
              filesArray.push({ filename: file.name, mime: file.type, base64 });
            }
            await this.$API.uploadFile(
              id,
              "new",
              null,
              "",
              filesArray,
              true,
              currentCategory.type
            );
          }
        }
      }
    },
    goBackRoute() {
      if (
        this.$router.prevRoute &&
        this.$router.prevRoute.path.includes("table")
      ) {
        this.$router.go(-1);
        return;
      }
      const hashData = JSON.parse(localStorage.getItem("hashData"));
      if (!hashData || !Object.keys(hashData).length) {
        return this.$router.push("/dashboard/surgeries");
      }
      const hash = getHash({});
      return this.$router.push("/dashboard/surgeries#" + hash);
    },
    onEdit() {
      if (!this.$route.params.id) return;
      this.$router.push("/surg-edit/" + this.$route.params.id);
    },
    async getDoc(url, name) {
      if (!url || !url.includes("https://md-booking.hmc.co.il/")) return;
      try {
        const res = await this.$API.getDocApp(url);

        const link = document.createElement("a");
        link.href = res.message;
        link.download = name;
        link.target = "_blank";
        link.click();
      } catch (error) {
        this.$modal.show(Error);
      }
    },
    cancelSurg(type = false) {
      if (this.surgery.payment_token) {
        const { popup, args } = getSurgeryErrorPopup();
        this.$modal.show(popup, { ...args });
        return;
      }

      this.$modal.show(
        CancelPop,
        {
          appointment_id: this.$route.params.id,
          appDate: "",
          isSurg: true,
          type: type
        },
        {
          clickToClose: true
        }
      );
    },
    getSelectTextByValue(selectType, value) {
      const find = this.surgerySelect[selectType].find(
        option => option.value == value
      );
      if (find) return find.text;
      return value;
    },
    openSmsPopup(id, patientName, patientPassport) {
      this.$modal.show(SMSToPatient, {
        patientName,
        patientPassport,
        surgId: id,
        eventType: "surgery"
      });
    },
    handleWhatsapp(patientPhone) {
      this.$modal.show(Whatsapp, { patientPhone });
    },
    addDirectDocs() {
      this.$modal.show(AddDocuments, {
        directUpload: { ...this.surgery, type: "surgery" }
      });
    },
    openPatientRequests() {
      this.$modal.show(PatientRequestsPopup, { event: this.surgery });
    },
    removeFile(indexRow, index) {
      this.$modal.show(ConfirmDelete, {
        onConfirm: () => {
          const type = this.files[indexRow]?.type;
          if (!type) return;
          const file = this.files[indexRow].files[index];

          this.$API.uploadFile(
            this.surgery.id,
            "cancel",
            file.id,
            file.name,
            [],
            true,
            type
          );
          this.files[indexRow].files.splice(index, 1);
        }
      });
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  watch: {
    surgery(val) {
      window.scrollTo(0, 0);
    }
  },
  computed: {
    ...mapGetters(["savedSurgery", "activeDoctor"]),
    ...mapState("Surgery", ["implantsList"]),
    surgeryDate() {
      if (!this.surgery || !this.surgery.start_date) return null;
      return new Date(this.surgery.start_date).format("DD/MM/YYYY");
    },
    surgeryTime() {
      if (!this.surgery || !this.surgery.start_time) return null;
      return this.$moment(this.surgery.start_time, "HH:mm:ss").format("HH:mm");
    },
    todayDate() {
      return this.$moment(new Date()).format("DD/MM/YYYY");
    },
    userLang() {
      if (!this.surgery || !this.surgery.user_language) return "";
      if (this.surgery.user_language == "hebrew") return "עברית";
      else if (this.surgery.user_language == "english") return "אנגלית";
      else if (this.surgery.user_language == "russian") return "רוסית";
      else if (this.surgery.user_language == "arabic") return "ערבית";
      else return "";
    },
    surgBeforeToday() {
      if (this.surgery?.tafnit_file_no) return false;
      if (!this.surgery?.start_date) return true;
      const surgDate = this.$moment(new Date(this.surgery.start_date));
      return this.$moment().isBefore(surgDate);
    },
    secondaryInsuranceLabel() {
      if (!this.surgery || !this.surgery.secondary_insurance_name) return "";
      const found = this.insuranceQuestions.insuranceCompanyOptions.find(
        i => i.text == this.surgery.secondary_insurance_name
      );
      return found ? "חברת ביטוח" : "קופת חולים";
    },
    secondaryInsurance() {
      if (this.secondaryInsuranceLabel != "קופת חולים")
        return this.surgery.secondary_insurance_name;
      return this.getShortCareServices(this.surgery.secondary_insurance_name);
    },
    existFiles() {
      if (!this.files?.length) return false;
      let exist = false;
      this.files.forEach(fileRow => {
        if (fileRow.files?.length) exist = true;
      });
      return exist;
    },
    getParentalStatus() {
      return this.parentalStatus.find(
        status => status.value == this.surgery.parental_status
      );
    },
    implants() {
      if (!this.surgery?.implants?.length) return "";

      const implantsNames = [];
      this.surgery.implants.forEach(implant => {
        // surgery.implants holds generic_item_id values. implantsList items can
        // come from two sources: the dropdown-options API (supplier_id/supplier_name/generic_item_id)
        // or the saved surgery response (id/name with empty supplier_name).
        const found = this.implantsList.find(
          i =>
            (i.id != null && i.id == implant) ||
            (i.generic_item_id != null && i.generic_item_id == implant)
        );
        if (found) {
          const displayName = found.name || found.supplier_name;
          if (displayName) implantsNames.push(displayName);
        }
      });

      let temp = implantsNames.join(", ");
      if (this.surgery?.custom_implant) {
        temp += ", " + this.surgery.custom_implant;
      }
      return temp;
    },
    displayedPatientRequests() {
      return getPatientRequestSummary(this.patientRequests);
    }
  },
  components: {
    Print,
    Logo,
    CloseSvg,
    ApproveMobileHeader,
    ApproveDesktopHeader,
    ApproveActions
  }
};
</script>

<style>
.reset-margin-bottom {
  margin-bottom: unset;
}

/* The indication text starts with an auto-generated BMI/OSA line followed by
   the doctor's own text, so its line breaks have to survive the summary. */
.keep-line-breaks {
  white-space: pre-line;
}

.aprove-sur-check {
  margin-top: 30px;
}
.aprove-sur-check .surgery-check {
  margin-right: 0 !important;
  font-size: 26px;
}
.surg-delete-scheduling {
  justify-content: start;
  gap: 12px;
  font-size: 22px;
  margin-bottom: 20px;
}
.scheduling-svg,
.msg-btn {
  width: 23px;
  position: relative;
  top: 1px;
}
.whatsapp-w {
  cursor: pointer;
  display: flex;
}
.sms-btn {
  margin: 0 22px;
}
.sms-btn-mobile {
  margin: 0 12px;
}
.btns-w {
  display: flex;
  gap: 0.55rem;
}
.surg-actions-container {
  justify-content: center;
  margin: 30px 0;
}
.surg-actions-container a {
  border: 1px solid #324997;
  padding: 5px 10px;
  border-radius: 5px;
}
.surg-logo {
  flex: 1;
}
.surg-msg-container {
  flex: 1;
  justify-content: end;
}
@media only screen and (max-width: 900px) {
  .aprove-sur-check .surgery-check {
    margin-right: 5px !important;
  }
  .surg-actions-container {
    margin-top: 10px;
    gap: 10px;
  }
  .surg-actions-container a img {
    margin-left: 7px;
  }
}
</style>
